type DiagnosticLogLevel = 'error' | 'warn' | 'debug';

const metaEnv = (import.meta as ImportMeta & { env?: Record<string, unknown> }).env ?? {};
const viteAppEnv = typeof metaEnv.VITE_APP_ENV === 'string' ? metaEnv.VITE_APP_ENV : undefined;
const isVitest =
  Boolean(metaEnv.VITEST) ||
  (typeof process !== 'undefined' && Boolean(process.env?.VITEST)) ||
  (typeof globalThis !== 'undefined' && '__vitest_worker__' in globalThis);

export const isVerboseClientDiagnostics =
  !isVitest && (metaEnv.DEV === true || viteAppEnv === 'development');

function currentUrl(): string {
  return typeof window !== 'undefined' ? window.location.href : 'ssr';
}

function currentAppEnv(): string {
  if (metaEnv.DEV === true) {
    return 'local';
  }
  return viteAppEnv ?? (metaEnv.PROD === true ? 'production-build' : 'unknown');
}

export function logClientDiagnostic(
  level: DiagnosticLogLevel,
  label: string,
  ...args: unknown[]
): void {
  if (!isVerboseClientDiagnostics) {
    return;
  }

  const prefix = `[${label}]`;
  switch (level) {
    case 'error':
      console.error(prefix, ...args);
      break;
    case 'warn':
      console.warn(prefix, ...args);
      break;
    case 'debug':
      console.debug(prefix, ...args);
      break;
  }
}

export function stashClientDiagnostic(
  label: string,
  verbosePayload: unknown,
  productionPayload: unknown = { message: 'Client diagnostic redacted in production.' },
): void {
  try {
    sessionStorage.setItem(
      'last-error',
      JSON.stringify({
        label,
        payload: isVerboseClientDiagnostics ? verbosePayload : productionPayload,
        redacted: !isVerboseClientDiagnostics,
        at: new Date().toISOString(),
        url: currentUrl(),
        appEnv: currentAppEnv(),
      }),
    );
  } catch {
    /* quota / private mode — non-critical */
  }
}
